import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div>
      <SEO
        title="Sayfa bulunamadı | Abonelik İptal"
        description="Aradığınız sayfa bulunamadı."
        path="/404"
        noindex
      />
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#4DA6A1] mb-3">
          404
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-[#0F3D4A]">
          Aradığınız sayfa bulunamadı.
        </h1>
        <p className="mt-4 text-[#0F3D4A]/70">
          Sayfa taşınmış veya kaldırılmış olabilir.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="fs-btn-primary inline-flex mt-8"
        >
          Ana sayfaya dön
        </Link>
      </div>
      <Footer />
    </div>
  );
}
